import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration
// Replace these with your actual Firebase project credentials
const firebaseConfig = {
  apiKey: "AIzaSyBBLmsPCYVzkvLmiwgnZUNN9hPgxSKVDXQ",
  authDomain: "learn-japanese-f657c.firebaseapp.com",
  projectId: "learn-japanese-f657c",
  storageBucket: "learn-japanese-f657c.firebasestorage.app",
  messagingSenderId: "692037272099",
  appId: "1:692037272099:web:1916ecb6313b056386a796",
  measurementId: "G-EMKFHC980M"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;
